import React from 'react';

const ConnectionLoader: React.FC = () => (
  <div className="h-screen bg-slate-950 flex flex-col items-center justify-center p-8 text-center space-y-12">
    <div className="flex items-center gap-8 relative">
      <div className="w-16 h-16 bg-white/10 rounded-2xl border border-white/20 flex items-center justify-center text-white text-xl font-bold animate-pulse">
        SaaS
      </div>
      <div className="flex gap-2">
        <div className="w-2 h-2 rounded-full bg-indigo-500 animate-ping"></div>
        <div className="w-2 h-2 rounded-full bg-indigo-500 animate-ping delay-100"></div>
        <div className="w-2 h-2 rounded-full bg-indigo-500 animate-ping delay-200"></div>
      </div>
      <div className="w-16 h-16 bg-indigo-600 rounded-2xl flex items-center justify-center text-white text-xl font-black shadow-2xl shadow-indigo-500/50">
        S
      </div>
    </div>
    <div className="space-y-3">
      <h2 className="text-2xl font-black text-white uppercase tracking-tight">Connecting...</h2>
      <p className="text-slate-400 font-medium max-w-sm">Setting up your account and billing...</p>
    </div>
    <div className="w-64 h-1 bg-white/5 rounded-full overflow-hidden">
      <div className="h-full bg-indigo-500 animate-[loading_2s_ease-in-out_infinite]"></div>
    </div>
    <style>{`
      @keyframes loading {
        0% { transform: translateX(-100%); }
        100% { transform: translateX(100%); }
      }
    `}</style>
  </div>
);

export default ConnectionLoader;
